import { tokens } from './tokens';

export const generateColorVariables = (colors, prefix = '--vp-color') => {
  const vars = {};
  Object.entries(colors).forEach(([colorName, shades]) => {
    if (typeof shades === 'object') {
      Object.entries(shades).forEach(([shade, value]) => {
        vars[`${prefix}-${colorName}-${shade}`] = value;
      });
    } else {
      vars[`${prefix}-${colorName}`] = shades;
    }
  });
  return vars;
};

export const generateSpacingVariables = (spacing, prefix = '--vp-space') => {
  const vars = {};
  Object.entries(spacing).forEach(([key, value]) => {
    vars[`${prefix}-${key}`] = `${value}px`;
  });
  return vars;
};

export const generateRadiusVariables = (radius, prefix = '--vp-radius') => {
  const vars = {};
  Object.entries(radius).forEach(([key, value]) => {
    vars[`${prefix}-${key}`] = value === 9999 ? '9999px' : `${value}px`;
  });
  return vars;
};

export const generateShadowVariables = (shadows, prefix = '--vp-shadow') => {
  const vars = {};
  Object.entries(shadows).forEach(([key, value]) => {
    vars[`${prefix}-${key}`] = value;
  });
  return vars;
};

export const generateTypographyVariables = (typography, prefix = '--vp') => {
  const vars = {};
  
  Object.entries(typography.fontWeight).forEach(([key, value]) => {
    vars[`${prefix}-font-weight-${key}`] = value;
  });
  
  Object.entries(typography.fontSize).forEach(([key, value]) => {
    vars[`${prefix}-font-size-${key}`] = value;
  });
  
  Object.entries(typography.lineHeight).forEach(([key, value]) => {
    vars[`${prefix}-line-height-${key}`] = value;
  });
  
  Object.entries(typography.letterSpacing).forEach(([key, value]) => {
    vars[`${prefix}-letter-spacing-${key}`] = value;
  });
  
  vars[`${prefix}-font-sans`] = typography.fontFamily.sans;
  vars[`${prefix}-font-mono`] = typography.fontFamily.mono;
  
  return vars;
};

export const generateTransitionVariables = (transitions, prefix = '--vp-transition') => {
  const vars = {};
  
  Object.entries(transitions.duration).forEach(([key, value]) => {
    vars[`${prefix}-duration-${key}`] = value;
  });
  
  Object.entries(transitions.easing).forEach(([key, value]) => {
    vars[`${prefix}-easing-${key}`] = value;
  });
  
  return vars;
};

export const generateZIndexVariables = (zIndex, prefix = '--vp-z') => {
  const vars = {};
  Object.entries(zIndex).forEach(([key, value]) => {
    vars[`${prefix}-${key}`] = value;
  });
  return vars;
};

export const generateAllCssVariables = () => ({
  ...generateColorVariables(tokens.colors),
  ...generateSpacingVariables(tokens.spacing),
  ...generateRadiusVariables(tokens.radius),
  ...generateShadowVariables(tokens.shadows),
  ...generateTypographyVariables(tokens.typography),
  ...generateTransitionVariables(tokens.transitions),
  ...generateZIndexVariables(tokens.zIndex),
  '--vp-touch-target-min': `${tokens.touchTargets.minimum}px`,
  '--vp-touch-target-recommended': `${tokens.touchTargets.recommended}px`,
  '--vp-touch-target-comfortable': `${tokens.touchTargets.comfortable}px`,
});

export const BASE_CSS_VARIABLES = generateAllCssVariables();

export const cssVar = (name) => `var(${name})`;

export const colorMix = (color1, color2, percentage = 50) =>
  `color-mix(in srgb, ${color1} ${percentage}%, ${color2})`;

export const colorWithAlpha = (colorVar, alpha) =>
  `color-mix(in srgb, ${cssVar(colorVar)} ${alpha * 100}%, transparent)`;

export default {
  generateAllCssVariables,
  BASE_CSS_VARIABLES,
  cssVar,
  colorMix,
  colorWithAlpha,
};
